import { FC, PropsWithChildren, ReactElement, useEffect } from 'react';
import { FormState } from 'react-hook-form';
import useAlertProvider from '../alert/useAlertProvider';
import { Button, Link } from '@digital-pulse/react';
import styles from './form.module.scss';

interface FormProps {
  errorTitle?: string;
  formState: FormState<any>;
  onSubmit: () => void;
  onCancel?: () => void;
  submitBtnText?: string;
  handleModal?: () => void;
  handleMinorModal?: () => void;
  cancelTag?: string;
  isUnifiedRegistration?: boolean;
}

const Form: FC<PropsWithChildren<FormProps>> = ({
  errorTitle,
  formState,
  onSubmit,
  children,
  submitBtnText = 'Submit'
}): ReactElement => {
  const { setAlerts } = useAlertProvider();

  useEffect(() => {
    if (formState.isSubmitSuccessful) {
      return;
    }
    setAlerts(
      Object.keys(formState.errors).length === 0
        ? []
        : [
            {
              title: errorTitle,
              actions: (
                <ul key={Object.keys(formState.errors).toString()}>
                  {Object.keys(formState.errors).map((error) => (
                    <li key={error + formState.errors[error]?.type}>
                      <Link
                        href="javascript:;"
                        variant="inline"
                        onClick={(ev) => {
                          ev.preventDefault();
                          const errEl = formState.errors[error]?.ref as HTMLElement;
                          errEl?.focus?.();
                        }}
                        subtype="high-contrast"
                      >
                        {formState.errors[error]?.message?.toString()}
                      </Link>
                    </li>
                  ))}
                </ul>
              )
            }
          ]
    );
  }, [
    errorTitle,
    formState.errors,
    formState.submitCount,
    formState.isSubmitSuccessful,
    setAlerts
  ]);

  return (
    <div>
      <div className={styles.form_container}>{children}</div>
      <div className={styles.button} id="button_container">
        <Button className={styles.button} onClick={onSubmit}>
          {submitBtnText}
        </Button>
      </div>
    </div>
  );
};

export default Form;
